export default "__VITE_ASSET__CQULLngA__"